/** Removes unwanted decimals from a price */
function truncateUnwatedDecimals(price: string) {
  const pieces = price.split('.');
  if (pieces.length > 1) {
    if (pieces[1] === '00') {
      return pieces[0];
    }
    return price;
  } else {
    return price;
  }
}

/** Returns a price prefixed with `$`, whether it's already prefixed with `$` or not. */
function ensurePriceIsPrefixed(price: string) {
  return typeof price === 'string' && price.startsWith('$') ? price : `$${price}`;
}

/**
 * Formats a `price` of the form $XX.XX to how the spec expects.
 *
 * Output Examples:
 * ---
 * ```
 * formatPrice('100')     => '$100'
 * formatPrice('100.00')  => '$100'
 * formatPrice('100.01')  => '$100.01'
 * formatPrice('$100')    => '$100'
 * formatPrice('$100.00') => '$100'
 * formatPrice('$100.01') => '$100.01'
 * ```
 */
export function formatPrice(price: string | undefined): string {
  if (price === undefined) return '';
  return truncateUnwatedDecimals(ensurePriceIsPrefixed(price));
}
